import { useViewerStore } from '../store/viewerStore';

export function ConnectionStatus() {
  const { connectionStatus, viewerCount } = useViewerStore();

  const statusConfig = {
    connecting: { color: 'bg-yellow-500', text: 'Connecting...', shortText: '...' },
    connected: { color: 'bg-green-500', text: 'Live', shortText: 'Live' },
    disconnected: { color: 'bg-gray-500', text: 'Reconnecting...', shortText: '...' },
    error: { color: 'bg-red-500', text: 'Error', shortText: 'Err' },
  };

  const config = statusConfig[connectionStatus];

  return (
    <div className="flex items-center gap-2 sm:gap-4">
      <div className="flex items-center gap-1 sm:gap-2">
        <span className={`w-2 h-2 rounded-full ${config.color} animate-pulse`} />
        <span className="hidden sm:inline text-sm font-medium text-gray-600">{config.text}</span>
        <span className="sm:hidden text-xs font-medium text-gray-600">{config.shortText}</span>
      </div>
      {connectionStatus === 'connected' && viewerCount > 0 && (
        <div className="flex items-center gap-1 text-xs sm:text-sm text-gray-500">
          <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          <span>{viewerCount}</span>
        </div>
      )}
    </div>
  );
}
